module.exports = __webpack_public_path__ + "img/apk-download-badge.07d555e9.png";